import type { State } from '../../../../state/reducer.tsx';
import { isSpinnerVisible } from '../../../../state/ui/delete/selectors.tsx';
import { isInitialising as isEditInitialising } from '../../../../state/ui/edit/selectors.tsx';

export const showSpinner = (state: State, id: string) => {
	if (isEditInitialising(state, id)) {
		return true;
	}

	return isSpinnerVisible(state, id);
};
